import type React from 'react';
import type { CSSProperties } from 'react';

import { MicBorderIcon, VideoBorderIcon, VideoIcon } from 'assets/svg-icons';

interface IRenderPrimaryIconBaseOnBaseUrl {
  primaryTextColor?: string;
  styles?: CSSProperties;
}

export const renderPrimaryIconBaseOnBaseUrl = ({
  primaryTextColor,
  styles
}: IRenderPrimaryIconBaseOnBaseUrl): React.ReactNode => {
  const currentURL = window.location.href;
  const borderdVideoIcons = ['marksandspencer'];
  const borderdAudioIcons = ['johnlewis', 'integration'];

  if (borderdVideoIcons.some((name) => currentURL.includes(name))) {
    return (
      <VideoBorderIcon
        style={styles}
        color={primaryTextColor}
      />
    );
  }

  if (borderdAudioIcons.some((name) => currentURL.includes(name))) {
    return (
      <MicBorderIcon
        style={styles}
        color={primaryTextColor}
      />
    );
  }

  return (
    <VideoIcon
      style={styles}
      color={primaryTextColor}
    />
  );
};
